module.exports = __webpack_public_path__ + "img/logout.ee0b3e1b.svg";